module.exports = __webpack_public_path__ + "media/front/images/logo-bb018bdb5d5c014ec1c7e0285774610e.svg";